import { TheSocietyType } from "../../static/types/commonTypes/theSocietyType";

type ValidationResult = {
    isValid: boolean;
    errors: { [key: string]: string };
  };

  const LegalFormWithSCOPSA = [
    "Société coopérative de production à forme anonyme à Conseil d'Administration",
    "Société coopérative de production à forme anonyme à Directoire",
    "Société coopérative d'intérêt collectif à forme anonyme à Conseil d'Administration",
    "Société coopérative d'intérêt collectif à forme anonyme à Directoire",
    "Société coopérative de production à responsabilité limitée",
    "Société coopérative d'intérêt collectif à responsabilité limitée",
    "Société coopérative de production par actions simplifiée",
    "Société coopérative d'intérêt collectif par actions simplifiée"
];
  
export function validateSociety(input: TheSocietyType): ValidationResult {
    const errors: { [key: string]: string } = {};

    if (!input.legalForm) {
        errors.legalForm = "La forme juridique est requise";
    }

    if (!input.object) {
        errors.object = "L'objet est requis";
    }

    if (typeof input.duration !== "number" || input.duration <= 0) {
        errors.duration = "La durée est requis et doit être positif";
    }

    if ( input.legalForm.includes("à capital variable") || LegalFormWithSCOPSA.includes(input.legalForm) ) {

        if( !input.initialCapital ){
            errors.initialCapital = "Le capital initial est requis";
        }

        if( !input.minimalCapital ){
            errors.minimalCapital = "Le capital minimal est requis";
        }
        if( !input.maximalCapital){
            errors.maximalCapital = "Le capital maximal est requis";
        }
        if (typeof input.minimalCapital !== "number" || input.minimalCapital <= 0) {
            errors.minimalCapital = "Le capital doit être un nombre positif";
        }
        if (typeof input.initialCapital !== "number" || input.initialCapital <= 0) {
            errors.minimalCapital = "Le capital doit être un nombre positif";
        }
        if (typeof input.maximalCapital !== "number" || input.maximalCapital <= 0) {
            errors.minimalCapital = "Le capital doit être un nombre positif";
        }
        else if ( input.maximalCapital && input.minimalCapital ) {
            if (typeof input.maximalCapital !== "number" || input.maximalCapital <= input.minimalCapital) {
                errors.minimalCapital = "Le capital minimal doit être inférieur au capital maximal";
            }
            if (typeof input.minimalCapital !== "number" || input.minimalCapital >= input.maximalCapital) {
                errors.maximalCapital = "Le capital maximal doit être supérieur au capital minimal";
            }
        }

        if( input.maximalCapital && input.minimalCapital){
            if (
                typeof input.initialCapital !== "number" ||
                input.initialCapital < input.minimalCapital ||
                input.initialCapital > input.maximalCapital
            ) {
                errors.initialCapital = "Le capital inital doit être compris entre le capital minimal et le capital maximal";
            }
        }
    }
    else if (!input.legalForm.includes("à capital variable")) {
        if (typeof input.capital !== "number" || input.capital <= 0) {
            errors.capital = "Le capital est requis";
        }
    }
    else {
        errors.legalForm = "Forme juridique invalide";
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
}
  